console.log('[MAPAPP] observer elindult');

function fixMapApp() {
    const target = document.querySelector('.cart__page > div.cart__page-col');
    const mapapp = document.querySelector('#mapApp');

    if (!target || !mapapp) return;

    if (mapapp.parentElement !== target) {
        console.log('[MAPAPP] visszahelyezés');
        target.appendChild(mapapp);
    }
}

const observer = new MutationObserver(() => {
    fixMapApp();
});

observer.observe(document.body, {
    childList: true,
    subtree: true
});









document.addEventListener("DOMContentLoaded", function () {

  // --- Nyelv lekérése ---
  const lang = document.documentElement.lang;

  // --- Szövegek nyelvenként ---
  const texts = {
    hu: {
      copy: "Másolás vágólapra →",
      copied: "Email cím másolva a vágólapra!"
    },
    de: {
      copy: "In Zwischenablage kopieren →",
      copied: "E-Mail-Adresse in die Zwischenablage kopiert!"
    },
    en: {
      copy: "Copy to clipboard →",
      copied: "Email address copied to clipboard!"
    },
    ro: {
      copy: "Masă de vânt →",
      copied: "Adresa de e-mail a fost copiată în clipboard!"
    }
  };

  const t = texts[lang] || texts.hu;

  function createPopup(emailLinkSelector) {

    const emailLink = document.querySelector(emailLinkSelector);

    if (!emailLink) return;

    const overlay = document.createElement("div");
    overlay.classList.add("overlay-popup");
    document.body.appendChild(overlay);

    const popup = document.createElement("div");
    popup.classList.add("email-popup");
    popup.innerHTML = `
      <button class="popup-close">X</button>
      <a href="mailto:info@kuvings-official.eu">info@kuvings-official.eu</a>
      <button class="copy-btn">${t.copy}</button>
    `;

    document.body.appendChild(popup);

    const closeButton = popup.querySelector(".popup-close");
    const copyButton = popup.querySelector(".copy-btn");

    function openPopup(event) {
      event.preventDefault();

      overlay.style.display = "block";
      popup.style.display = "block";
    }

    emailLink.addEventListener("click", openPopup);

    closeButton.addEventListener("click", () => {
      overlay.style.display = "none";
      popup.style.display = "none";
    });

    overlay.addEventListener("click", () => {
      overlay.style.display = "none";
      popup.style.display = "none";
    });

    copyButton.addEventListener("click", () => {
      navigator.clipboard.writeText("info@kuvings-official.eu")
        .then(() => {
          alert(t.copied);
        });
    });
  }

  createPopup("#Footer-custom_rKHjV4 > div > div > p:nth-child(2) > a");
  createPopup("#shopify-section-template--29847526408530__rich-text > div > div > div > div > div:nth-child(2) > p:nth-child(3) > a");
  createPopup("#shopify-section-template--29847526408530__rich-text > div > div > div:nth-child(1) > p:nth-child(3) > a")

});